












import { Vue, Component, Prop } from 'vue-property-decorator';
import InviteMerchantSignupService from '@/api/InviteMerchantSignupService';
import { handleIframeMessage } from '@/utils/getPostMessageIframe';
import ManagerService from '@/api/ManagerService';
import { setMerchantMeetingOboardingState } from '@/router/router-utils';

interface ITimeRange {
  end: number;
  start: number;
}

export interface IMeetingData {
  date: string;
  datetime: number;
  duration: number;
  timerange: ITimeRange;
}

export interface IHubspotForm {
  firstName: string;
  lastName: string;
  email: string;
  company?: string;
}

@Component({
  components: {}
})
export default class OnboardingMeetingSchedulingHubspotIframe extends Vue {
  @Prop() hubspotParams!: IHubspotForm;

  content: any;

  iframeSrc: string | null = '';

  inviteMerchantSignupService = new InviteMerchantSignupService();
  managerService = new ManagerService();

  async mounted() {
    this.$showLoaderWithLocker();
    await this.getIframe();
  }

  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  }

  async getIframe() {
    const {
      data
    } = await this.managerService.scheduleCallIframeHubspotIntegration(
      this.hubspotParams
    );

    const blob = new Blob([data], { type: 'text/html' });
    this.iframeSrc = URL.createObjectURL(blob);

    window.addEventListener('message', this.handleMessage);
    this.$hideLoader();
  }

  async handleMessage(event: MessageEvent) {
    const iframeResponse = await handleIframeMessage(event);

    if (!iframeResponse || !JSON.parse(iframeResponse)) return;

    const data = JSON.parse(iframeResponse);

    if (data && data.meetingBookSucceeded) {
      const meetingsPayload: any = data.meetingsPayload.bookingResponse;
      const meetingData: IMeetingData = {
        date: meetingsPayload.event.dateString,
        datetime: meetingsPayload.event.dateTime,
        duration: meetingsPayload.event.duration,
        timerange: meetingsPayload.postResponse.timerange
      };

      setMerchantMeetingOboardingState(meetingData);

      setTimeout(() => {
        this.$emit('onConfirm');
      }, 2000);
    }
  }
}
